module.exports = __webpack_public_path__ + "assets/img/landing-top-notebook.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing-top-notebook.png
// module id = 1947
// module chunks = 0